import React from "react";
import { config } from "../../../../../../config";
import { Pill } from "../../../../../Atoms/Pill/Pill";

const TestPill = () => {
  return config.isProd === "false" ? (
    <Pill size="md" className="border-red-cardinal ml-2 border" theme="light">
      TEST
    </Pill>
  ) : null;
};

export default TestPill;
